import { connect } from 'react-redux'
import settingsSelector from './settingsSelector'
import Settings from './Settings'

export default connect(
  settingsSelector,
  {}
)(Settings)
